export default __webpack_public_path__ + "static/icon-9-1-8e4a58f568994fb0776f5bbe5209d4dc.png";